module.exports = __webpack_public_path__ + "img/1528540866.0b9d96d1.jpg";